import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';

// services
import { LoginService } from '../../../shared/services/login.service';
import { CopyService } from '../../../shared/services/app-copy.service';

// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

// models
import { AppState } from '../../../booking/models/app-state.interface';

@Component({
  selector: 'app-one-factor',
  templateUrl: './one-factor.component.html',
  styleUrls: ['./one-factor.component.scss']
})
export class OneFactorComponent implements OnInit, OnDestroy {

  @Input()
  userEmail;

  @Input()
  userName;

  @Output()
  closeOverlay: EventEmitter<any> = new EventEmitter();

  @Output()
  toggleLoginType: EventEmitter<any> = new EventEmitter();

  private _tokenSubscription: Subscription;
  private _userSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _bookingInitSubscription: Subscription;

  public maskPassword = true;
  public showLoader = false;
  public appCopy;
  public copyLoaded: Boolean = false;
  public selectedLanguage = '';
  public showCurrencyWithPrice = '';

  constructor(
    private _appStore: Store<AppState>,
    private _loginService: LoginService,
    private _copyService: CopyService,
    private _activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {

    this.showCurrencyWithPrice = this._activatedRoute.snapshot.queryParams.currencySymbol;
    this._userLanguageSubscription = this._appStore.select('copyReducer')
    .subscribe((res: any) => {
    this.selectedLanguage = res.language
    })

    this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
        .subscribe((res: any) => {
          this.copyLoaded = res.copyLoaded;
            if (res.copyLoaded) {
              this.getCopy();
            }

        })

    this._tokenSubscription = this._loginService.tokenSubject$
      .subscribe(token => {

        if (token.error) {
          this.handleErrors();
        }
        this.showLoader = false;
      },
        err => {
          console.log(err);
          this.showLoader = false;
        });

    this._userSubscription = this._loginService.userSubject$
      .subscribe(user => {

        if (user.error) {
          this.handleErrors();
        }

        this.showLoader = false;
        this.handleCloseOverlay();
      },
        err => {
          console.log(err);
          this.showLoader = false;
        });
  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'login',
      ['one-factor']
    );
    console.log(panelHeaderCopy)

    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };

  }

  handleErrors() {
    this.showLoader = false;
  }

  showNoPasswordLogin() {
    this.toggleLoginType.emit(2);
  }

  handleLogin(password: string, e: Event) {
    e.preventDefault();

    this.showLoader = true;

    if (password !== '') {
      const encodedPassword = encodeURIComponent(password);
      const params = 'grant_type=password&username=' + encodeURIComponent(this.userEmail) + '&password=' + encodedPassword;

      const storeCookie = true;
      const isGuest = false;

      this._loginService.getToken(params, storeCookie, isGuest, this.userEmail);
      this._loginService.userHasPassword();
    } else {
      this.handleCloseOverlay();
    }
  }

  handleCloseOverlay() {
    this.closeOverlay.emit();
  }

  ngOnDestroy() {
    this._tokenSubscription.unsubscribe();
    this._userSubscription.unsubscribe();
    this._userLanguageSubscription.unsubscribe();
  }

}
